<script>
  import Notification from "../components/Notification.svelte";
  import Header from "../components/Header.svelte";
  import emailjs from "emailjs-com";
  import Footer from "../components/Footer.svelte";

  let firstName = "";
  let lastName = "";
  let email = "";
  let phoneNumber = "";
  let message = "";
  let helpOptions = [
    "General Inquiry",
    "Technical Support",
    "Feedback",
    "Other",
  ];
  let sourceOptions = ["Social Media", "Search Engine", "Referral", "Other"];
  let selectedHelp = "";
  let selectedSource = "";

  let toastMessage = "";
  let notificationType = "";
  let showToast = false;

  const serviceID = "service_ypc1kbf";
  const templateID = "template_ntsapyf";
  const userID = "1BNWVR2DcIGPph14X";

  async function handleSubmit() {
    const templateParams = {
      to_name: "TruLens Team",
      from_name: `${firstName} ${lastName}`,
      email,
      phone_number: phoneNumber,
      help_option: selectedHelp,
      source_option: selectedSource,
      message,
    };

    try {
      await emailjs.send(serviceID, templateID, templateParams, userID);

      toastMessage =
        "Thank you for reaching out! We'll get back to you shortly.";
      notificationType = "success";
      showToast = true;

      setTimeout(() => {
        showToast = false;
      }, 3000);

      resetForm();
    } catch (error) {
      console.error("EmailJS Error:", error);

      toastMessage =
        "There was an issue sending your request. Please try again later.";
      notificationType = "danger";
      showToast = true;

      setTimeout(() => {
        showToast = false;
      }, 3000);
    }
  }

  function resetForm() {
    firstName =
      lastName =
      email =
      phoneNumber =
      message =
      selectedHelp =
      selectedSource =
        "";
  }

  function handleSupport() {
    window.location.href = "#/customer-support";
  }
</script>

<LandingHeader />
<br />

<Notification
  message={toastMessage}
  show={showToast}
  type={notificationType}
  on:close={() => (showToast = false)}
/>

<div class="card-container">
  <div class="card-left">
    <h3 style="color: gray;">Contact Us</h3>
    <h1>We're Here to Help</h1>
    <p style="color: gray;">
      Discover how we assist businesses in verifying the authenticity and
      provenance of digital media.
      <br /><br />
      From ensuring C2PA compliance to providing dependable virtual inspections,
      TruLens fosters transparency and trust in every image and video.
      <br /><br />
      Please complete this brief form, and we will respond promptly.
      <br /><br />
      For direct inquiries, contact us at
      <span style="color: blue;">admin@trulens.ae</span>
      <br /><br />
      If you need assistance with TruLens Vision, feel free to reach out.
    </p>
    <button class="button-support" on:click={handleSupport}>
      Contact Support
    </button>
  </div>

  <br />

  <div class="card-right">
    <div class="form-container">
      <form on:submit|preventDefault={handleSubmit} class="contact-form">
        <div class="name-container">
          <div class="name-field">
            <label for="firstName">First Name</label>
            <input type="text" bind:value={firstName} required id="firstName" />
          </div>
          <div class="name-field">
            <label for="lastName">Last Name</label>
            <input type="text" bind:value={lastName} required id="lastName" />
          </div>
        </div>

        <label for="email">Email</label>
        <input type="email" bind:value={email} required id="email" />

        <label for="phone">Phone Number</label>
        <input type="tel" bind:value={phoneNumber} required id="phone" />

        <label for="helpOptions">How can we help you?</label>
        <select id="helpOptions" bind:value={selectedHelp} required>
          <option value="" disabled selected>Select an option</option>
          {#each helpOptions as option}
            <option value={option}>{option}</option>
          {/each}
        </select>

        <label for="sourceOptions">How did you hear about us?</label>
        <select id="sourceOptions" bind:value={selectedSource} required>
          <option value="" disabled selected>Select an option</option>
          {#each sourceOptions as option}
            <option value={option}>{option}</option>
          {/each}
        </select>

        <label for="message">Message and any additional details:</label>
        <textarea bind:value={message} required id="message"></textarea>

        <button type="submit" class="button-submit">Submit</button>
      </form>
    </div>
  </div>
</div>

<br /><br />
<Footer />

<style>
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }

  h1 {
    font-size: 1.5em;
  }

  h3 {
    font-size: 1em;
  }

  .card-container {
    display: flex;
    flex-direction: column; /* Stack elements on small screens */
    width: 90%;
    max-width: 1000px; /* Set max width */
    margin: auto;
    padding: 1.5%; /* Remove padding */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: #f9f9f9;
  }

  @media (min-width: 768px) {
    .card-container {
      flex-direction: row; /* Row layout for larger screens */
    }

    .card-left {
      padding-right: 20px; /* Adjusted padding */
      flex: 1;
    }

    .card-right {
      flex: 1;
    }

    h1 {
      font-size: 2.5em;
    }

    h3 {
      font-size: 1.5em;
    }
  }

  .form-container {
    background-color: #f0f0f0;
    padding: 15px; /* Keep some padding */
    border-radius: 8px;
  }

  .contact-form {
    display: flex;
    flex-direction: column;
    gap: 10px; /* Maintain a bit of space */
    padding: 5px;
  }

  .name-container {
    display: flex;
    flex-wrap: wrap; /* Allow wrapping on small screens */
    gap: 10px; /* Maintain some gap */
  }

  .name-field {
    flex: 1;
    min-width: 120px; /* Minimum width for name fields */
  }

  input,
  textarea,
  select {
    width: 100%;
    padding: 10px; /* Sufficient padding for touch targets */
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 0; /* Remove margin */
  }

  label {
    margin-bottom: 5px; /* Slightly more space above labels */
  }

  .button-submit,
  .button-support {
    background-color: #4423ff;
    color: white;
    padding: 10px; /* Sufficient padding for touch targets */
    border: none;
    cursor: pointer;
    margin-top: 10px; /* Space above buttons */
  }

  .button-submit:hover,
  .button-support:hover {
    background-color: #1c00b9;
  }
</style>
